module.exports = __webpack_public_path__ + "static/img/logo-header.5177915.png";


//////////////////
// WEBPACK FOOTER
// ./resources/holataxi/img/logo-header.png
// module id = Iig0
// module chunks = 1